<script>
export default {
  page: {
    title: 'Share record link expired',
    meta: [
      { name: 'description', content: 'The share record link expire page.' },
    ],
  },
}
</script>

<template>
  <v-container class="pt-16">
    <v-row justify="center" class="pl-4 pr-3">
      <v-col cols="12" md="1" sm="12" class="py-0">&nbsp;</v-col>
      <v-col cols="12" md="5" sm="12" class="py-0">
        <p :class="$style.headText">This link has expired</p>

        <p :class="$style.subheadText"
          >Please contact the sender to generate a new email invite. Links
          expire within 24 hours of being sent.</p
        >
      </v-col>
      <v-col cols="12" md="5" sm="12" class="py-0">
        <div align="center">
          <img
            width="350"
            height="400"
            :class="$style.logo"
            :src="
              require(this.$route.params.base === 'health-vault'
                ? '@assets/images/safehaven/SharingDocuments03.svg'
                : '@assets/images/safehaven/SharingRecords01.svg')
            "
          />
        </div>
      </v-col>
      <v-col cols="12" md="1" sm="12" class="py-0">&nbsp;</v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.logo {
  height: auto;
}
.headText {
  align-items: center;
  font-size: 22px;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: #09101d;
}

.subheadText {
  margin-bottom: 20px !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #09101d;
}
</style>
